import { alpha, useTheme } from '@mui/material/styles';

export const useStyles = () => {
  const theme = useTheme();
  return {
    root: {
      minHeight: 'calc(100vh - 75px)',
      display: 'grid',
      gridAutoFlow: 'row',
    },
    bodyContainer: {
      position: 'relative',
      minHeight: '700px',
      backgroundColor: theme.colorTokens.surfaceContainerLowest,
      [theme.breakpoints.down('sm')]: {
        minHeight: '500px',
      },
    },
    cover: {
      position: 'absolute',
      inset: 0,
      width: '100%',
      height: '100%',
      objectFit: 'cover',
    },
    mainContainer: {
      position: 'absolute',
      top: '30%',
      left: '60px',
      [theme.breakpoints.down('md')]: {
        inset: '100px 20px 0',
      },
      [theme.breakpoints.down('sm')]: {
        inset: 0,
      },
    },
    mainFormInner: {
      width: '700px',
      padding: '24px 32px',
      backgroundColor: alpha(theme.colorTokens.secondary, 0.6),
      color: theme.colorTokens.onSecondary,
      boxSizing: 'border-box',
      [theme.breakpoints.down('md')]: {
        width: '100%',
      },
      [theme.breakpoints.down('sm')]: {
        maxWidth: '100%',
        width: '100%',
        margin: 0,
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
        justifyContent: 'center',
      },
    },
    mainFormTitle: {
      fontSize: '40px',
      fontWeight: 400,
      [theme.breakpoints.down('sm')]: {
        fontSize: '24px',
        textAlign: 'center',
      },
    },
    mainFormSubTitle: {
      fontSize: '22px',
      fontWeight: 400,
      letterSpacing: '0.5%',
      margin: '30px 0 20px',
      [theme.breakpoints.down('sm')]: {
        fontSize: '16px',
        textAlign: 'center',
      },
    },
    formInputWrapper: {
      display: 'flex',
      alignItems: 'center',
      gap: '1rem',
      [theme.breakpoints.down('sm')]: {
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
      },
    },
    formInput: {
      borderRadius: '4px',
      backgroundColor: theme.colorTokens.surfaceContainerLowest,
    },
    submitBtn: {
      padding: '16px 32px',
      fontWeight: 700,
      [theme.breakpoints.down('sm')]: {
        width: '100%',
      },
    },
  };
};
